// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".leftRadius[data-v-003042cc]{border-radius:10px 0 0 10px!important;border:1px solid #dfdfdf;border-right:.5px}.rightRadius[data-v-003042cc]{border-radius:0 10px 10px 0!important}", ""]);
// Exports
module.exports = exports;
